// Web browsers provide Intl; Metro selects intlPolyfills.native.ts on native.
export {};
